import type { SVGAttributes } from 'react';

export function ObjectivesIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props} viewBox="0 0 32 32">
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M16 26c5.523 0 10-4.477 10-10S21.523 6 16 6 6 10.477 6 16s4.477 10 10 10"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-14.666V2.667M5.335 16H2.668M16 26.667v2.667M26.668 16h2.667"
				opacity=".4"
			/>
		</svg>
	);
}
